export const flattenQueryParam = (queryParam?: string | string[], defaultValue?: string) => {
  if (queryParam) {
    return typeof queryParam === 'string' ? queryParam : queryParam.join(',');
  }
  return defaultValue;
};
